"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function ScienceOfProtection() {
  const {
    ref: headingRef,
    isVisible: headingVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section id="scienceofprotection" className="bg-background text-white py-16 px-6 !h-[600px] lg:px-12">
      <div className="max-w-7xl mx-auto">
        <div ref={headingRef} className={`mb-12 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${headingVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <h1 className="font-display font-bold text-center text-white !text-[40px]">The Fair CEO Protected Advantage</h1>
        </div>

        <div className="flex flex-col items-center gap-16">
          <div ref={imageRef} className={`w-full max-w-5xl transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${imageVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <img src="https://sincere-skink.10web.cloud/wp-content/uploads/2026/02/How-CEOs-Can-Gain-a-Protected-Advantage-in-the-2020-Aftermath.png" alt="Science of Protection" className="w-full object-cover rounded-lg shadow-medium" />
          </div>

          <h2 className="text-center font-display font-bold text-white ![margin:-30px_0px_0px_0px] !text-3xl">The #1 Most Important Skill CEO’s Must Possess</h2>

          <div className="!-mt-8">
            <Link to="https://newmavericks.com/download" newTab>
              <Button className="bg-primary inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive shadow-xs has-[>svg]:px-3 text-white font-bold px-13 py-5 text-xl transition-all duration-200 !bg-[hsl(43,96%,56%)] !h-[60px] lg:text-3xl disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:bg-orange-700">Download</Button>
            </Link>
          </div>

          <div ref={textRef} className={`w-full max-w-3xl transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${textVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            
          </div>
        </div>
      </div>
    </section>;
}